import { batchTransactionRoutes } from './routes';
import { useBatchTransactionStore } from './stores/batch-transaction-store';

export interface ModuleConfig {
  name: string;
  routes: typeof batchTransactionRoutes;
  stores: Record<string, unknown>;
  initialize?: () => void;
  cleanup?: () => void;
}

export const BatchTransactionModule: ModuleConfig = {
  name: 'batch-transactions',
  routes: batchTransactionRoutes,
  stores: {
    batchTransaction: useBatchTransactionStore,
  },
  initialize: () => {
    console.log('Batch Transaction module initialized');
  },
  cleanup: () => {
    useBatchTransactionStore.getState().reset();
    console.log('Batch Transaction module cleaned up');
  },
};

// Re-export types
export * from './types';

// Re-export hooks
export { useBatchConfig } from './hooks/useBatchConfig';
export { useBatchJob } from './hooks/useBatchJob';

// Re-export main view
export { default as BatchTransactionView } from './views/BatchTransactionView';

export default BatchTransactionModule;
